var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.isExpired ? '已超過邀請時間，無法邀請' : '卡友身份認證中'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }